<template>
  <div>
<!--    <q-json>{{ element }}</q-json>-->
<!--    <q-json>{{ model }}</q-json>-->
    <div v-if="fromStructure">
      <q-form
        ref="detailForm"
        :model="model"
        :rules="rules"
        label-width="150px"
      >
        <q-form-generator
          v-model="model"
          :form-structure="fromStructure"
        />
      </q-form>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'QBPMNElementDetail',
    props: {
      value: {type: Object, required: true},
      element: {type: Object, required: true},
      fromStructure: {type: Object, required: true},
    },
    data() {
      return {
        model: undefined,

        rules: {}
      };
    },
    computed: {
      getRules() {
        return {};
      }
    },

    watch: {
      model() {
        this.$emit('input', this.model);
      },
      value() {
        this.model = this.value;
      }
    },
    created() {
      this.model = this.value;
    }
  }
</script>

<style scoped>

</style>
